import { useQuery } from '@tanstack/react-query';

import { NOTE_PUSH_TARGETS_QUERY_KEY } from '../../../contracts/note-push-targets-query-key';
import {
  getComputerUseNotePushTargets,
  type ComputerUseNotePushTargetRow,
} from './placement-store';

/**
 * Read-only hydration of the stored note-push placements for a template+app, for
 * the verification panel. Scoped explicitly by `workspaceId` (never a global
 * atom) + `templateId` + `appName`; disabled until a workspace is known. The
 * panel treats these rows as the AUTHORITATIVE stored mapping and the ephemeral
 * candidate store as overrides/field-candidates scratch.
 */
export const useQueryComputerUseNotePushTargets = (params: {
  templateId: string;
  /** Scoped to one app when given; `null`/omitted fetches ALL apps' rows. */
  appName?: string | null;
  workspaceId: string | null;
  enabled?: boolean;
}) =>
  useQuery<ComputerUseNotePushTargetRow[]>({
    queryKey: [
      NOTE_PUSH_TARGETS_QUERY_KEY,
      params.workspaceId,
      params.templateId,
      params.appName,
    ],
    queryFn: async () => {
      const outcome = await getComputerUseNotePushTargets({
        templateId: params.templateId,
        appName: params.appName,
        workspaceId: params.workspaceId,
      });
      if (!outcome.ok) throw new Error(outcome.error);
      return outcome.value;
    },
    enabled: (params.enabled ?? true) && Boolean(params.workspaceId),
  });
